// extracted by mini-css-extract-plugin
module.exports = {"spinner":"CardLoading_spinner__1fO_i","spinnerContainer":"CardLoading_spinnerContainer__SlH5b"};